import { ReactComponent as Contract } from "../assets/icons/ContractIcon.svg";
const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4C7.93188 4 8.39782 4 8.76537 4.15224C9.25542 4.35523 9.64477 4.74458 9.84776 5.23463C10 5.60218 10 6.06812 10 7C10 7.93188 10 8.39782 9.84776 8.76537C9.64477 9.25542 9.25542 9.64477 8.76537 9.84776C8.39782 10 7.93188 10 7 10C6.06812 10 5.60218 10 5.23463 9.84776C4.74458 9.64477 4.35523 9.25542 4.15224 8.76537C4 8.39782 4 7.93188 4 7Z"
        stroke="#B0B0B0"
        stroke-width="1.5"
      />
      <path
        d="M14 7C14 6.06812 14 5.60218 14.1522 5.23463C14.3552 4.74458 14.7446 4.35523 15.2346 4.15224C15.6022 4 16.0681 4 17 4C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7C20 7.93188 20 8.39782 19.8478 8.76537C19.6448 9.25542 19.2554 9.64477 18.7654 9.84776C18.3978 10 17.9319 10 17 10C16.0681 10 15.6022 10 15.2346 9.84776C14.7446 9.64477 14.3552 9.25542 14.1522 8.76537C14 8.39782 14 7.93188 14 7Z"
        stroke="#B0B0B0"
        stroke-width="1.5"
      />
      <path
        d="M4 17C4 16.0681 4 15.6022 4.15224 15.2346C4.35523 14.7446 4.74458 14.3552 5.23463 14.1522C5.60218 14 6.06812 14 7 14C7.93188 14 8.39782 14 8.76537 14.1522C9.25542 14.3552 9.64477 14.7446 9.84776 15.2346C10 15.6022 10 16.0681 10 17C10 17.9319 10 18.3978 9.84776 18.7654C9.64477 19.2554 9.25542 19.6448 8.76537 19.8478C8.39782 20 7.93188 20 7 20C6.06812 20 5.60218 20 5.23463 19.8478C4.74458 19.6448 4.35523 19.2554 4.15224 18.7654C4 18.3978 4 17.9319 4 17Z"
        stroke="#B0B0B0"
        stroke-width="1.5"
      />
      <path
        d="M14 17C14 16.0681 14 15.6022 14.1522 15.2346C14.3552 14.7446 14.7446 14.3552 15.2346 14.1522C15.6022 14 16.0681 14 17 14C17.9319 14 18.3978 14 18.7654 14.1522C19.2554 14.3552 19.6448 14.7446 19.8478 15.2346C20 15.6022 20 16.0681 20 17C20 17.9319 20 18.3978 19.8478 18.7654C19.6448 19.2554 19.2554 19.6448 18.7654 19.8478C18.3978 20 17.9319 20 17 20C16.0681 20 15.6022 20 15.2346 19.8478C14.7446 19.6448 14.3552 19.2554 14.1522 18.7654C14 18.3978 14 17.9319 14 17Z"
        stroke="#B0B0B0"
        stroke-width="1.5"
      />
    </svg>
  );
};
const ProfileIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.812 5H4.188C3.53189 5 3 5.53189 3 6.188V16.9215C3 17.5777 3.53189 18.1095 4.188 18.1095H19.812C20.4681 18.1095 21 17.5777 21 16.9215V6.188C21 5.53189 20.4681 5 19.812 5Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2666 10.0029H18.0176"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.2666 12.7295H18.0176"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.16406 10.4574C7.16406 11.7121 8.18121 12.7293 9.43594 12.7293C9.75314 12.7293 10.0552 12.6643 10.3294 12.5469C11.1399 12.1998 11.7078 11.3949 11.7078 10.4574C11.7078 9.2027 10.6907 8.18555 9.43594 8.18555C8.18121 8.18555 7.16406 9.2027 7.16406 10.4574Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.98242 14.979C6.34342 14.2923 6.85078 13.7248 7.45574 13.3311C8.06069 12.9373 8.74289 12.7305 9.43675 12.7305C10.1306 12.7305 10.8128 12.9373 11.4178 13.3311C12.0227 13.7248 12.5301 14.2923 12.8911 14.979"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const AccountMetricsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M6 7L6 13"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 9V13"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 5V13"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="1"
        y="1"
        width="18"
        height="16"
        rx="2"
        stroke="white"
        stroke-width="1.3"
      />
    </svg>
  );
};

const BillingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M11.3845 9.30762H4.46143"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3845 12.7695H4.46143"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3845 5.8457H4.46143"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9231 1H3.76923C3.03479 1 2.33042 1.29176 1.81109 1.81109C1.29176 2.33042 1 3.03479 1 3.76923V19L4.46154 16.9231L7.92308 19L11.3846 16.9231L14.8462 19V3.07692C14.8462 2.5261 15.0649 1.99781 15.4544 1.60832C15.8439 1.21882 16.3723 1 16.9231 1ZM16.9231 1C17.4739 1 18.0022 1.21882 18.3917 1.60832C18.7812 1.99781 19 2.5261 19 3.07692V7.92308H14.8462"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const AffiliateIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
    >
      <circle cx="8.1998" cy="5.4" r="4.75" stroke="white" stroke-width="1.3" />
      <circle
        cx="8.2001"
        cy="4.0502"
        r="1.35"
        stroke="white"
        stroke-width="1.3"
      />
      <circle cx="2.8" cy="16.2004" r="1.8" stroke="white" stroke-width="1.3" />
      <circle
        cx="13.5998"
        cy="16.2004"
        r="1.8"
        stroke="white"
        stroke-width="1.3"
      />
      <path
        d="M11.5752 9.1125C11.5752 7.62133 10.0642 6.75 8.2002 6.75C6.33623 6.75 4.8252 7.62133 4.8252 9.1125"
        stroke="white"
        stroke-width="1.3"
      />
      <path
        d="M8.1998 10.3496V12.1496M8.1998 12.1496H3.79981C3.24752 12.1496 2.7998 12.5973 2.7998 13.1496V14.3996M8.1998 12.1496H12.5998C13.1521 12.1496 13.5998 12.5973 13.5998 13.1496V14.3996"
        stroke="white"
        stroke-width="1.3"
      />
    </svg>
  );
};

const GetFundedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.96618 15.2609L2.25655 14.6793H2.25655L1.96618 15.2609ZM8.03382 15.2609L7.74345 14.6793H7.74345L8.03382 15.2609ZM4.46618 18.2609L4.75655 17.6793H4.75655L4.46618 18.2609ZM10.5338 18.2609L10.2434 17.6793H10.2434L10.5338 18.2609ZM8.74404 13.4397C8.38896 13.3869 8.05829 13.6319 8.00545 13.9869C7.95262 14.342 8.19764 14.6727 8.55271 14.7255L8.74404 13.4397ZM2.46618 22.2609L2.75655 21.6793H2.75655L2.46618 22.2609ZM8.53382 22.2609L8.24345 21.6793L8.53382 22.2609ZM4.23687 18.7605C4.58991 18.6955 4.8234 18.3566 4.75836 18.0035C4.69333 17.6505 4.35441 17.417 4.00137 17.482L4.23687 18.7605ZM9.15101 18.4234C8.89257 18.1742 8.48109 18.1817 8.23192 18.4402C7.98275 18.6986 7.99026 19.1101 8.2487 19.3593L9.15101 18.4234ZM10.5187 6.89178C10.735 6.60533 10.6782 6.19771 10.3918 5.98134C10.1053 5.76497 9.69771 5.82177 9.48134 6.10822L10.5187 6.89178ZM17.5187 6.10822C17.3023 5.82177 16.8947 5.76497 16.6082 5.98134C16.3218 6.19771 16.265 6.60533 16.4813 6.89178L17.5187 6.10822ZM9.73914 2.57241L10.3446 2.33591V2.33591L9.73914 2.57241ZM10.384 1.96482L10.6802 1.38625V1.38625L10.384 1.96482ZM10.9261 2.24238L11.2223 1.6638L10.9261 2.24238ZM11.3769 2.22465L11.0366 1.67083V1.67083L11.3769 2.22465ZM13.2588 1.0684L13.5991 1.62223V1.62223L13.2588 1.0684ZM13.7412 1.0684L14.0814 0.51458V0.51458L13.7412 1.0684ZM15.5894 2.20393L15.2491 2.75776L15.2491 2.75776L15.5894 2.20393ZM16.0906 2.19172L16.457 2.72856V2.72856L16.0906 2.19172ZM16.3084 2.04302L15.9419 1.50618V1.50618L16.3084 2.04302ZM17.0281 2.53653L16.3901 2.41193V2.41193L17.0281 2.53653ZM20.3076 19.4061C20.5318 19.1257 20.4864 18.7167 20.2061 18.4924C19.9257 18.2682 19.5167 18.3136 19.2924 18.5939L20.3076 19.4061ZM18.8 20.25L18.2924 19.8439L17.9676 20.25L18.2924 20.6561L18.8 20.25ZM19.2924 21.9061C19.5167 22.1864 19.9257 22.2318 20.2061 22.0076C20.4864 21.7833 20.5318 21.3743 20.3076 21.0939L19.2924 21.9061ZM21.3 20.9C21.659 20.9 21.95 20.609 21.95 20.25C21.95 19.891 21.659 19.6 21.3 19.6V20.9ZM7.85 12.5C7.85 12.5001 7.85004 12.501 7.84944 12.5035C7.84881 12.5062 7.84705 12.5123 7.84232 12.5222C7.83255 12.5427 7.81013 12.5788 7.76232 12.6273C7.66312 12.7278 7.48734 12.8481 7.21883 12.9632C6.6841 13.1924 5.90008 13.35 5 13.35V14.65C6.03292 14.65 6.99889 14.4718 7.73092 14.1581C8.09578 14.0017 8.43257 13.7989 8.68759 13.5405C8.94536 13.2793 9.15 12.9269 9.15 12.5H7.85ZM5 13.35C4.09992 13.35 3.3159 13.1924 2.78117 12.9632C2.51266 12.8481 2.33688 12.7278 2.23768 12.6273C2.18987 12.5788 2.16745 12.5427 2.15768 12.5222C2.15295 12.5123 2.15119 12.5062 2.15056 12.5035C2.14996 12.501 2.15 12.5001 2.15 12.5H0.85C0.85 12.9269 1.05464 13.2793 1.31241 13.5405C1.56743 13.7989 1.90422 14.0017 2.26908 14.1581C3.00111 14.4718 3.96708 14.65 5 14.65V13.35ZM2.15 12.5C2.15 12.4999 2.14996 12.499 2.15056 12.4965C2.15119 12.4938 2.15295 12.4877 2.15768 12.4778C2.16745 12.4573 2.18987 12.4212 2.23768 12.3727C2.33688 12.2722 2.51266 12.1519 2.78117 12.0368C3.3159 11.8076 4.09992 11.65 5 11.65V10.35C3.96708 10.35 3.00111 10.5282 2.26908 10.8419C1.90422 10.9983 1.56743 11.2011 1.31241 11.4595C1.05464 11.7207 0.85 12.0731 0.85 12.5H2.15ZM5 11.65C5.90008 11.65 6.6841 11.8076 7.21883 12.0368C7.48734 12.1519 7.66312 12.2722 7.76232 12.3727C7.81013 12.4212 7.83255 12.4573 7.84232 12.4778C7.84705 12.4877 7.84881 12.4938 7.84944 12.4965C7.85004 12.499 7.85 12.4999 7.85 12.5H9.15C9.15 12.0731 8.94536 11.7207 8.68759 11.4595C8.43257 11.2011 8.09578 10.9983 7.73092 10.8419C6.99889 10.5282 6.03292 10.35 5 10.35V11.65ZM0.85 12.5V14.4648H2.15V12.5H0.85ZM9.15 14.4648V12.5H7.85V14.4648H9.15ZM1.67581 15.8424C2.31884 16.1635 3.53109 16.65 5 16.65V15.35C3.80706 15.35 2.8003 14.9508 2.25655 14.6793L1.67581 15.8424ZM5 16.65C6.46891 16.65 7.68116 16.1635 8.32419 15.8424L7.74345 14.6793C7.1997 14.9508 6.19294 15.35 5 15.35V16.65ZM7.85 14.4648C7.85 14.5893 7.79138 14.6554 7.74345 14.6793L8.32419 15.8424C8.87453 15.5676 9.15 15.0091 9.15 14.4648H7.85ZM0.85 14.4648C0.85 15.0091 1.12547 15.5676 1.67581 15.8424L2.25655 14.6793C2.20862 14.6554 2.15 14.5893 2.15 14.4648H0.85ZM10.35 15.5C10.35 15.5001 10.35 15.501 10.3494 15.5035C10.3488 15.5062 10.3471 15.5123 10.3423 15.5222C10.3325 15.5427 10.3101 15.5788 10.2623 15.6273C10.1631 15.7278 9.98734 15.8481 9.71883 15.9632C9.1841 16.1924 8.40008 16.35 7.5 16.35V17.65C8.53292 17.65 9.49889 17.4718 10.2309 17.1581C10.5958 17.0017 10.9326 16.7989 11.1876 16.5405C11.4454 16.2793 11.65 15.9269 11.65 15.5H10.35ZM7.5 16.35C6.59992 16.35 5.8159 16.1924 5.28117 15.9632C5.01266 15.8481 4.83688 15.7278 4.73768 15.6273C4.68987 15.5788 4.66745 15.5427 4.65768 15.5222C4.65295 15.5123 4.65119 15.5062 4.65056 15.5035C4.64996 15.501 4.65 15.5001 4.65 15.5H3.35C3.35 15.9269 3.55464 16.2793 3.81241 16.5405C4.06743 16.7989 4.40422 17.0017 4.76908 17.1581C5.50111 17.4718 6.46708 17.65 7.5 17.65V16.35ZM3.35 15.5V17.4648H4.65V15.5H3.35ZM11.65 17.4648V15.5H10.35V17.4648H11.65ZM4.17581 18.8424C4.81884 19.1635 6.03109 19.65 7.5 19.65V18.35C6.30706 18.35 5.3003 17.9508 4.75655 17.6793L4.17581 18.8424ZM7.5 19.65C8.96891 19.65 10.1812 19.1635 10.8242 18.8424L10.2434 17.6793C9.6997 17.9508 8.69294 18.35 7.5 18.35V19.65ZM10.35 17.4648C10.35 17.5893 10.2914 17.6554 10.2434 17.6793L10.8242 18.8424C11.3745 18.5676 11.65 18.0091 11.65 17.4648H10.35ZM3.35 17.4648C3.35 18.0091 3.62546 18.5676 4.17581 18.8424L4.75655 17.6793C4.70862 17.6554 4.65 17.5893 4.65 17.4648H3.35ZM8.55271 14.7255C9.18343 14.8194 9.68371 14.9899 10.0063 15.1809C10.1668 15.276 10.2608 15.3629 10.3097 15.4265C10.3329 15.4568 10.3428 15.4777 10.3468 15.4882C10.3488 15.4935 10.3495 15.4966 10.3498 15.498C10.35 15.4993 10.35 15.4998 10.35 15.5H11.65C11.65 14.8224 11.1516 14.3484 10.6688 14.0624C10.1578 13.7597 9.48226 13.5495 8.74404 13.4397L8.55271 14.7255ZM8.35 19.5C8.35 19.5001 8.35004 19.501 8.34944 19.5035C8.34881 19.5062 8.34705 19.5123 8.34232 19.5222C8.33255 19.5427 8.31013 19.5788 8.26232 19.6273C8.16312 19.7278 7.98734 19.8481 7.71883 19.9632C7.1841 20.1924 6.40008 20.35 5.5 20.35V21.65C6.53292 21.65 7.49889 21.4718 8.23092 21.1581C8.59578 21.0017 8.93257 20.7988 9.18759 20.5405C9.44536 20.2793 9.65 19.9269 9.65 19.5H8.35ZM5.5 20.35C4.59992 20.35 3.8159 20.1924 3.28117 19.9632C3.01266 19.8481 2.83688 19.7278 2.73768 19.6273C2.68987 19.5788 2.66745 19.5427 2.65768 19.5222C2.65295 19.5123 2.65119 19.5062 2.65056 19.5035C2.64996 19.501 2.65 19.5001 2.65 19.5H1.35C1.35 19.9269 1.55464 20.2793 1.81241 20.5405C2.06743 20.7988 2.40422 21.0017 2.76908 21.1581C3.50111 21.4718 4.46708 21.65 5.5 21.65V20.35ZM1.35 19.5V21.4648H2.65V19.5H1.35ZM9.65 21.4648V19.5H8.35V21.4648H9.65ZM2.17581 22.8424C2.81884 23.1635 4.03109 23.65 5.5 23.65V22.35C4.30706 22.35 3.3003 21.9508 2.75655 21.6793L2.17581 22.8424ZM5.5 23.65C6.96891 23.65 8.18116 23.1635 8.82419 22.8424L8.24345 21.6793C7.6997 21.9508 6.69294 22.35 5.5 22.35V23.65ZM8.35 21.4648C8.35 21.5893 8.29138 21.6554 8.24345 21.6793L8.82419 22.8424C9.37453 22.5676 9.65 22.0091 9.65 21.4648H8.35ZM1.35 21.4648C1.35 22.0091 1.62547 22.5676 2.17581 22.8424L2.75655 21.6793C2.70862 21.6554 2.65 21.5893 2.65 21.4648H1.35ZM2.65 19.5C2.65 19.4998 2.65 19.4993 2.65019 19.4982C2.65039 19.4971 2.65096 19.4944 2.65253 19.49C2.65568 19.4811 2.66366 19.4631 2.68284 19.4365C2.72314 19.3807 2.80246 19.3018 2.9419 19.2128C3.22304 19.0333 3.66568 18.8657 4.23687 18.7605L4.00137 17.482C3.32622 17.6064 2.70931 17.819 2.24247 18.117C1.7961 18.4019 1.35 18.8606 1.35 19.5H2.65ZM8.2487 19.3593C8.30324 19.4118 8.32933 19.4517 8.34091 19.4749C8.34649 19.486 8.34858 19.493 8.34934 19.4961C8.35005 19.499 8.35 19.4999 8.35 19.5H9.65C9.65 19.0528 9.42604 18.6886 9.15101 18.4234L8.2487 19.3593ZM16.4813 6.89178C17.4764 8.20917 18.4505 9.66679 19.1736 11.1322C19.9002 12.6047 20.35 14.0385 20.35 15.3201H21.65C21.65 13.7563 21.1085 12.1155 20.3394 10.557C19.5669 8.99142 18.541 7.46166 17.5187 6.10822L16.4813 6.89178ZM10.6875 4.4502H16.3125V3.1502H10.6875V4.4502ZM16.3125 6.03017H10.6875V7.33017H16.3125V6.03017ZM10.6875 6.03017C10.2843 6.03017 9.93125 5.69109 9.93125 5.24018H8.63125C8.63125 6.37984 9.53743 7.33017 10.6875 7.33017V6.03017ZM17.0688 5.24018C17.0688 5.69109 16.7157 6.03017 16.3125 6.03017V7.33017C17.4626 7.33017 18.3687 6.37984 18.3687 5.24018H17.0688ZM16.3125 4.4502C16.7157 4.4502 17.0688 4.78928 17.0688 5.24018H18.3687C18.3687 4.10053 17.4626 3.1502 16.3125 3.1502V4.4502ZM10.6875 3.1502C9.53742 3.1502 8.63125 4.10053 8.63125 5.24018H9.93125C9.93125 4.78928 10.2843 4.4502 10.6875 4.4502V3.1502ZM10.8242 3.56369L10.3446 2.33591L9.13369 2.80892L9.6133 4.0367L10.8242 3.56369ZM10.0878 2.5434L10.6299 2.82095L11.2223 1.6638L10.6802 1.38625L10.0878 2.5434ZM11.7172 2.77847L13.5991 1.62223L12.9186 0.51458L11.0366 1.67083L11.7172 2.77847ZM13.4009 1.62223L15.2491 2.75776L15.9296 1.65011L14.0814 0.51458L13.4009 1.62223ZM16.457 2.72856L16.6749 2.57985L15.9419 1.50618L15.7241 1.65488L16.457 2.72856ZM16.3901 2.41193L16.1433 3.6756L17.4192 3.9248L17.666 2.66113L16.3901 2.41193ZM16.6749 2.57985C16.6485 2.59788 16.6077 2.61208 16.5617 2.61086C16.5197 2.60975 16.4858 2.59622 16.4616 2.57964C16.4114 2.54516 16.3776 2.47611 16.3901 2.41193L17.666 2.66113C17.8511 1.71365 16.8046 0.917281 15.9419 1.50618L16.6749 2.57985ZM15.2491 2.75776C15.6231 2.98751 16.095 2.97573 16.457 2.72856L15.7241 1.65488C15.7847 1.61349 15.8664 1.61122 15.9296 1.65011L15.2491 2.75776ZM13.5991 1.62223C13.5388 1.65926 13.4612 1.65926 13.4009 1.62223L14.0814 0.51458C13.7243 0.29514 13.2757 0.29514 12.9186 0.51458L13.5991 1.62223ZM10.6299 2.82095C10.9755 2.99794 11.3868 2.98144 11.7172 2.77847L11.0366 1.67083C11.0921 1.63672 11.1633 1.6336 11.2223 1.6638L10.6299 2.82095ZM10.3446 2.33591C10.3541 2.36035 10.3582 2.39647 10.3489 2.43406C10.3404 2.46804 10.3232 2.4947 10.3027 2.51401C10.2822 2.5333 10.2511 2.55208 10.2085 2.55941C10.1616 2.5675 10.1173 2.55852 10.0878 2.5434L10.6802 1.38625C9.71755 0.893365 8.77441 1.88915 9.13369 2.80892L10.3446 2.33591ZM9.48134 6.10822C8.29594 7.67752 7.26099 9.2967 6.40797 11.1788L7.59203 11.7154C8.39564 9.94236 9.3749 8.40595 10.5187 6.89178L9.48134 6.10822ZM13.5 22.35C11.8307 22.35 10.4478 21.8941 9.37675 21.1323L8.62325 22.1917C9.93484 23.1246 11.5868 23.65 13.5 23.65V22.35ZM17.1715 21.4244C16.1743 22.0083 14.9449 22.35 13.5 22.35V23.65C15.1541 23.65 16.614 23.2574 17.8285 22.5462L17.1715 21.4244ZM20.35 15.3201C20.35 15.9437 20.2873 16.5425 20.1665 17.1085L21.4379 17.3798C21.5785 16.7206 21.65 16.0308 21.65 15.3201H20.35ZM22.35 20C22.35 21.2979 21.2979 22.35 20 22.35V23.65C22.0158 23.65 23.65 22.0158 23.65 20H22.35ZM20 22.35C18.7021 22.35 17.65 21.2979 17.65 20H16.35C16.35 22.0158 17.9842 23.65 20 23.65V22.35ZM17.65 20C17.65 18.7021 18.7021 17.65 20 17.65V16.35C17.9842 16.35 16.35 17.9842 16.35 20H17.65ZM20 17.65C21.2979 17.65 22.35 18.7021 22.35 20H23.65C23.65 17.9842 22.0158 16.35 20 16.35V17.65ZM19.2924 18.5939L18.2924 19.8439L19.3076 20.6561L20.3076 19.4061L19.2924 18.5939ZM18.2924 20.6561L19.2924 21.9061L20.3076 21.0939L19.3076 19.8439L18.2924 20.6561ZM18.8 20.9H21.3V19.6H18.8V20.9Z"
        fill="white"
      />
    </svg>
  );
};
const CompetitionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
    >
      <path
        d="M1 15.4236C1 14.8713 1.44772 14.4236 2 14.4236H4.96608V18.9998H1V15.4236Z"
        stroke="white"
        stroke-width="1.3"
      />
      <path
        d="M4.96631 12.9829C4.96631 12.4306 5.41402 11.9829 5.96631 11.9829H8.93239V18.9998H4.96631V12.9829Z"
        stroke="white"
        stroke-width="1.3"
      />
      <path
        d="M8.93211 5.57625H8.26375C7.84334 5.57625 7.61062 5.08894 7.87487 4.76197L10.5263 1.48119C10.7264 1.23356 11.1039 1.23356 11.304 1.48119L13.9554 4.76197C14.2197 5.08894 13.987 5.57625 13.5665 5.57625H12.8982V18.9999H8.93211V5.57625Z"
        stroke="white"
        stroke-width="1.3"
      />
      <path
        d="M12.8984 8.01685H15.8645C16.4168 8.01685 16.8645 8.46456 16.8645 9.01685V18.9998H12.8984V8.01685Z"
        stroke="white"
        stroke-width="1.3"
      />
    </svg>
  );
};

const AccountsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
    >
      <path
        d="M16.2308 17.6154C16.2308 17.9826 16.0849 18.3348 15.8253 18.5944C15.5655 18.8541 15.2134 19 14.8462 19H2.38462C2.01739 19 1.66521 18.8541 1.40554 18.5944C1.14588 18.3348 1 17.9826 1 17.6154V2.38462C1 2.01739 1.14588 1.66521 1.40554 1.40554C1.66521 1.14588 2.01739 1 2.38462 1H10.1188C10.486 1 10.8382 1.14588 11.0978 1.40554L15.8253 6.13292C16.0849 6.39258 16.2308 6.74477 16.2308 7.11198V17.6154Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.88867 8.5H13.3502"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3.5"
        y="7"
        width="3"
        height="3"
        rx="0.5"
        stroke="white"
        stroke-width="1.3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.0001 11.3496C3.36497 11.3496 2.8501 11.8645 2.8501 12.4996V14.4996C2.8501 15.1347 3.36497 15.6496 4.0001 15.6496H6.0001C6.63523 15.6496 7.1501 15.1347 7.1501 14.4996V12.4996C7.1501 11.8645 6.63522 11.3496 6.0001 11.3496H4.0001ZM4.1501 14.3496V12.6496H5.8501V14.3496H4.1501ZM8.88889 12.8496C8.52991 12.8496 8.23889 13.1406 8.23889 13.4996C8.23889 13.8586 8.52991 14.1496 8.88889 14.1496H13.3504C13.7094 14.1496 14.0004 13.8586 14.0004 13.4996C14.0004 13.1406 13.7094 12.8496 13.3504 12.8496H8.88889Z"
        fill="white"
      />
    </svg>
  );
};
const LeaderboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M15.7259 7.37223C15.7259 10.8915 12.8729 13.7445 9.35366 13.7445C5.83438 13.7445 2.98145 10.8915 2.98145 7.37223C2.98145 3.85294 5.83438 1 9.35366 1C12.8729 1 15.7259 3.85294 15.7259 7.37223Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.61436 3.91235L10.4921 5.67808C10.5117 5.72274 10.5429 5.76139 10.5823 5.79008C10.6218 5.81877 10.6681 5.83647 10.7167 5.84138L12.6661 6.13738C12.7218 6.14463 12.7744 6.16761 12.8175 6.20361C12.8607 6.23961 12.8927 6.28715 12.9098 6.34068C12.9269 6.39421 12.9285 6.45152 12.9142 6.50588C12.9 6.56025 12.8706 6.60944 12.8294 6.64771L11.3903 8.01538C11.3688 8.05632 11.3576 8.10185 11.3576 8.14807C11.3576 8.19429 11.3688 8.23982 11.3903 8.28076L11.6659 10.22C11.6776 10.276 11.6729 10.3343 11.6522 10.3877C11.6315 10.4411 11.5957 10.4874 11.5493 10.5209C11.5028 10.5543 11.4476 10.5736 11.3904 10.5764C11.3332 10.5792 11.2765 10.5653 11.227 10.5364L9.49188 9.61781C9.44697 9.59752 9.39825 9.58703 9.34899 9.58703C9.2997 9.58703 9.251 9.59752 9.20609 9.61781L7.47098 10.5364C7.42152 10.5653 7.36473 10.5792 7.30753 10.5764C7.25033 10.5736 7.19514 10.5543 7.14869 10.5209C7.10223 10.4874 7.06648 10.4411 7.0458 10.3877C7.0251 10.3343 7.02034 10.276 7.0321 10.22L7.35871 8.28076C7.37275 8.23574 7.37544 8.18795 7.36654 8.14165C7.35763 8.09536 7.33741 8.05198 7.30767 8.01538L5.86856 6.6375C5.83038 6.59884 5.80359 6.5504 5.79111 6.49752C5.77863 6.44463 5.78096 6.38933 5.79783 6.33768C5.81469 6.28603 5.84545 6.24002 5.88672 6.20469C5.92801 6.16935 5.97822 6.14607 6.03186 6.13738L7.98131 5.85159C8.02984 5.84668 8.07619 5.82898 8.11565 5.80029C8.1551 5.77159 8.18622 5.73295 8.20584 5.68829L9.08361 3.92256C9.1071 3.87257 9.14411 3.83015 9.19044 3.80011C9.23677 3.77006 9.29059 3.75356 9.34581 3.7525C9.40103 3.75144 9.45544 3.76584 9.5029 3.7941C9.55035 3.82235 9.58896 3.86331 9.61436 3.91235Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.83374 10.498L1 15.4062L4.06193 14.5858L4.88237 17.6477L7.34107 13.3892"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8804 10.498L17.7141 15.4062L14.6522 14.5858L13.8317 17.6477L11.373 13.3892"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const PayoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M9.35693 15.1426V17.714"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5713 13.8574V16.4289"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.14307 13.8574V16.4289"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4286 1H2.28571C1.57563 1 1 1.57563 1 2.28571V10C1 10.7101 1.57563 11.2857 2.28571 11.2857H16.4286C17.1387 11.2857 17.7143 10.7101 17.7143 10V2.28571C17.7143 1.57563 17.1387 1 16.4286 1Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.35693 8.39258C10.5996 8.39258 11.6069 7.38522 11.6069 6.14258C11.6069 4.89994 10.5996 3.89258 9.35693 3.89258C8.11429 3.89258 7.10693 4.89994 7.10693 6.14258C7.10693 7.38522 8.11429 8.39258 9.35693 8.39258Z"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.92494 6.46415C3.74743 6.46415 3.60352 6.32024 3.60352 6.14272C3.60352 5.9652 3.74743 5.82129 3.92494 5.82129"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.9248 6.46415C4.10232 6.46415 4.24623 6.32024 4.24623 6.14272C4.24623 5.9652 4.10232 5.82129 3.9248 5.82129"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.7892 6.46415C14.6116 6.46415 14.4678 6.32024 14.4678 6.14272C14.4678 5.9652 14.6116 5.82129 14.7892 5.82129"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.7891 6.46415C14.9666 6.46415 15.1105 6.32024 15.1105 6.14272C15.1105 5.9652 14.9666 5.82129 14.7891 5.82129"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const DownloadsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 1V9.30769"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.23047 6.53906L9.9997 9.30829L12.7689 6.53906"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4615 3.07715H18.3077C18.69 3.07715 19 3.38711 19 3.76946V14.8464C19 15.2287 18.69 15.5387 18.3077 15.5387H1.69231C1.30996 15.5387 1 15.2287 1 14.8464V3.76946C1 3.38711 1.30996 3.07715 1.69231 3.07715H6.53846"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.61508 15.5391L7.23047 19.0006"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3848 15.5391L12.7694 19.0006"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.84619 19H14.1539"
        stroke="white"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const CertificatesIcon = () => {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="#ffffff"
      stroke="#ffffff"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <title>certificate-ssl</title>{" "}
        <g id="Layer_2" data-name="Layer 2">
          {" "}
          <g id="invisible_box" data-name="invisible box">
            {" "}
          </g>{" "}
          <g id="icons_Q2" data-name="icons Q2">
            {" "}
            <g>
              {" "}
              <path d="M20,39H6V9H40a2,2,0,0,0,0-4H4A2,2,0,0,0,2,7V41a2,2,0,0,0,2,2H20a2,2,0,0,0,0-4Z"></path>{" "}
              <path d="M46,24A13,13,0,0,0,33,11a12.8,12.8,0,0,0-8.3,3H12a2,2,0,0,0,0,4h9.5a11.1,11.1,0,0,0-1.3,4H12a2,2,0,0,0,0,4h8.2a11.1,11.1,0,0,0,1.3,4H12a2,2,0,0,0,0,4H24.7l1.3.9v9.7A2.3,2.3,0,0,0,28,47a1.8,1.8,0,0,0,1.3-.6L33,43l3.7,3.4A1.8,1.8,0,0,0,38,47a2.3,2.3,0,0,0,2-2.4V35A13.2,13.2,0,0,0,46,24ZM36,32.5v7.8l-3-2.8-3,2.8V32.5A9.1,9.1,0,0,1,24,24a9,9,0,0,1,18,0A9.1,9.1,0,0,1,36,32.5Z"></path>{" "}
              <circle cx="33" cy="24" r="5"></circle>{" "}
            </g>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>
  );
};
const AlphaTicksIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask id="path-1-inside-1_990_2931" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.6372 3.71206C18.5886 3.54554 18.5625 3.36951 18.5625 3.1875C18.5625 2.15368 19.4037 1.3125 20.4375 1.3125C21.4713 1.3125 22.3125 2.15368 22.3125 3.1875C22.3125 4.22131 21.4713 5.0625 20.4375 5.0625C19.9929 5.0625 19.584 4.90695 19.2622 4.64741L16.6132 6.41325C16.6616 6.57939 16.6875 6.75499 16.6875 6.93652C16.6875 7.97034 15.8463 8.81152 14.8125 8.81152C13.7787 8.81152 12.9375 7.97034 12.9375 6.93652C12.9375 6.85297 12.943 6.77068 12.9536 6.68999L10.5691 5.57783C10.2261 5.95175 9.73366 6.18652 9.1875 6.18652C8.6414 6.18652 8.14905 5.9518 7.80604 5.57795L5.42141 6.6904C5.43202 6.77096 5.4375 6.85312 5.4375 6.93652C5.4375 7.97034 4.59631 8.81152 3.5625 8.81152C2.52868 8.81152 1.6875 7.97034 1.6875 6.93652C1.6875 5.90271 2.52868 5.06152 3.5625 5.06152C4.10915 5.06152 4.60193 5.29671 4.94498 5.67121L7.32878 4.55914C7.31804 4.47811 7.3125 4.39545 7.3125 4.31152C7.3125 3.27771 8.15369 2.43652 9.1875 2.43652C10.2213 2.43652 11.0625 3.27771 11.0625 4.31152C11.0625 4.39545 11.057 4.47811 11.0462 4.55915L13.4302 5.67102C13.7732 5.29663 14.2659 5.06152 14.8125 5.06152C15.2575 5.06152 15.6669 5.21741 15.9888 5.47746L18.6372 3.71206ZM19.8238 3.61817L19.8143 3.60339C19.8108 3.59822 19.8073 3.59312 19.8037 3.5881C19.7301 3.47212 19.6875 3.33468 19.6875 3.1875C19.6875 2.77405 20.0239 2.4375 20.4375 2.4375C20.8511 2.4375 21.1875 2.77405 21.1875 3.1875C21.1875 3.60095 20.8511 3.9375 20.4375 3.9375C20.1841 3.9375 19.9596 3.81115 19.8238 3.61817ZM15.4208 6.4983C15.2845 6.30959 15.0626 6.18652 14.8125 6.18652C14.5185 6.18652 14.2635 6.35655 14.1406 6.60336L14.1334 6.61953C14.1307 6.62532 14.1279 6.63104 14.1251 6.63669C14.0848 6.72857 14.0625 6.82999 14.0625 6.93652C14.0625 7.34998 14.3989 7.68652 14.8125 7.68652C15.2261 7.68652 15.5625 7.34998 15.5625 6.93652C15.5625 6.79327 15.5221 6.65924 15.4521 6.54525C15.4465 6.53771 15.4411 6.52999 15.4358 6.52209C15.4306 6.51424 15.4256 6.50631 15.4208 6.4983ZM9.1875 5.06152C9.48258 5.06152 9.73834 4.89025 9.86071 4.64196L9.86632 4.62954L9.87322 4.61526C9.91453 4.52236 9.9375 4.41957 9.9375 4.31152C9.9375 3.89807 9.60114 3.56152 9.1875 3.56152C8.77386 3.56152 8.4375 3.89807 8.4375 4.31152C8.4375 4.42347 8.46216 4.52978 8.50634 4.6253L8.50841 4.6297L8.50956 4.63218C8.62998 4.88574 8.88856 5.06152 9.1875 5.06152ZM4.23126 6.59721C4.10721 6.35372 3.85405 6.18652 3.5625 6.18652C3.14886 6.18652 2.8125 6.52307 2.8125 6.93652C2.8125 7.34998 3.14886 7.68652 3.5625 7.68652C3.97614 7.68652 4.3125 7.34998 4.3125 6.93652C4.3125 6.83252 4.29122 6.73339 4.25278 6.64326C4.2488 6.63565 4.24498 6.62792 4.24132 6.62006C4.23778 6.61248 4.23443 6.60486 4.23126 6.59721Z"
        />
        <path d="M12.3745 19.3125H12.7499C13.0606 19.3125 13.3124 19.0605 13.3124 18.75C13.3124 18.4395 13.0606 18.1875 12.7499 18.1875H12.3745C12.0638 18.1875 11.812 18.4395 11.812 18.75C11.812 19.0605 12.0638 19.3125 12.3745 19.3125Z" />
        <path d="M20.6249 19.3125H20.2495C19.9388 19.3125 19.687 19.0605 19.687 18.75C19.687 18.4395 19.9388 18.1875 20.2495 18.1875H20.6249C20.9356 18.1875 21.1874 18.4395 21.1874 18.75C21.1874 19.0605 20.9356 19.3125 20.6249 19.3125Z" />
        <path d="M13.4503 16.4962C13.5602 16.6061 13.7041 16.661 13.848 16.661C13.9919 16.661 14.1359 16.6061 14.2457 16.4962C14.4655 16.2765 14.4655 15.9205 14.2457 15.7008L13.9802 15.4353C13.7605 15.2156 13.4045 15.2156 13.1848 15.4353C12.9651 15.655 12.9651 16.011 13.1848 16.2307L13.4503 16.4962Z" />
        <path d="M16.5 15.5632C16.1893 15.5632 15.9375 15.3113 15.9375 15.0007V14.625C15.9375 14.3145 16.1893 14.0625 16.5 14.0625C16.8107 14.0625 17.0625 14.3145 17.0625 14.625V15.0007C17.0625 15.3113 16.8107 15.5632 16.5 15.5632Z" />
        <path d="M18.7537 16.4962C18.8635 16.6061 19.0074 16.661 19.1514 16.661C19.2953 16.661 19.4392 16.6061 19.5491 16.4962L19.8146 16.2307C20.0343 16.011 20.0343 15.655 19.8146 15.4353C19.5949 15.2156 19.2389 15.2156 19.0192 15.4353L18.7537 15.7008C18.5339 15.9205 18.5339 16.2765 18.7537 16.4962Z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.5 21.1875C15.5695 21.1875 14.8125 20.4305 14.8125 19.5C14.8125 18.7666 15.2827 18.141 15.9375 17.9089V16.875C15.9375 16.5645 16.1893 16.3125 16.5 16.3125C16.8107 16.3125 17.0625 16.5645 17.0625 16.875V17.9089C17.7173 18.141 18.1875 18.7666 18.1875 19.5C18.1875 20.4305 17.4305 21.1875 16.5 21.1875ZM16.5 18.9375C16.1898 18.9375 15.9375 19.1898 15.9375 19.5C15.9375 19.8102 16.1898 20.0625 16.5 20.0625C16.8102 20.0625 17.0625 19.8102 17.0625 19.5C17.0625 19.1898 16.8102 18.9375 16.5 18.9375Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.6875 18.75C22.6875 16.3504 21.3143 14.2653 19.3125 13.2394V7.3125H21.5625V13.5C21.5625 13.8105 21.8143 14.0625 22.125 14.0625C22.4357 14.0625 22.6875 13.8105 22.6875 13.5V6.75C22.6875 6.43946 22.4357 6.1875 22.125 6.1875H18.75C18.4393 6.1875 18.1875 6.43946 18.1875 6.75V12.7964C17.8248 12.6934 17.4487 12.6228 17.0625 12.5878V10.2129C17.0625 9.90235 16.8107 9.65039 16.5 9.65039H13.125C12.8143 9.65039 12.5625 9.90235 12.5625 10.2129V13.9805C11.3248 15.0041 10.4906 16.4993 10.3378 18.188H8.0625V8.30469H10.3125V13.5001C10.3125 13.8107 10.5643 14.0626 10.875 14.0626C11.1857 14.0626 11.4375 13.8107 11.4375 13.5001V7.74219C11.4375 7.43164 11.1857 7.17969 10.875 7.17969H7.5C7.18927 7.17969 6.9375 7.43164 6.9375 7.74219V18.188H5.8125V10.2119C5.8125 9.90137 5.56073 9.64941 5.25 9.64941H1.875C1.56427 9.64941 1.3125 9.90137 1.3125 10.2119V18.7505C1.3125 19.061 1.56427 19.313 1.875 19.313H10.3378C10.441 20.4531 10.8577 21.5325 11.5582 22.4634C11.6646 22.6044 11.831 22.6875 12.0077 22.6875H20.9923C21.169 22.6875 21.3354 22.6044 21.4418 22.4634C22.2567 21.3805 22.6875 20.0966 22.6875 18.75ZM21.5625 18.75C21.5625 15.9648 19.302 13.698 16.5194 13.6875C16.513 13.6878 16.5065 13.6879 16.5 13.6879C16.4935 13.6879 16.487 13.6878 16.4806 13.6875C13.698 13.698 11.4375 15.9648 11.4375 18.75C11.4375 19.7589 11.7339 20.7257 12.2974 21.5625H20.7026C21.2661 20.7257 21.5625 19.7589 21.5625 18.75ZM15.9375 10.7754V12.5878C15.1336 12.6606 14.3736 12.8878 13.6875 13.2394V10.7754H15.9375ZM2.4375 18.188H4.6875V10.7744H2.4375V18.188Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6372 3.71206C18.5886 3.54554 18.5625 3.36951 18.5625 3.1875C18.5625 2.15368 19.4037 1.3125 20.4375 1.3125C21.4713 1.3125 22.3125 2.15368 22.3125 3.1875C22.3125 4.22131 21.4713 5.0625 20.4375 5.0625C19.9929 5.0625 19.584 4.90695 19.2622 4.64741L16.6132 6.41325C16.6616 6.57939 16.6875 6.75499 16.6875 6.93652C16.6875 7.97034 15.8463 8.81152 14.8125 8.81152C13.7787 8.81152 12.9375 7.97034 12.9375 6.93652C12.9375 6.85297 12.943 6.77068 12.9536 6.68999L10.5691 5.57783C10.2261 5.95175 9.73366 6.18652 9.1875 6.18652C8.6414 6.18652 8.14905 5.9518 7.80604 5.57795L5.42141 6.6904C5.43202 6.77096 5.4375 6.85312 5.4375 6.93652C5.4375 7.97034 4.59631 8.81152 3.5625 8.81152C2.52868 8.81152 1.6875 7.97034 1.6875 6.93652C1.6875 5.90271 2.52868 5.06152 3.5625 5.06152C4.10915 5.06152 4.60193 5.29671 4.94498 5.67121L7.32878 4.55914C7.31804 4.47811 7.3125 4.39545 7.3125 4.31152C7.3125 3.27771 8.15369 2.43652 9.1875 2.43652C10.2213 2.43652 11.0625 3.27771 11.0625 4.31152C11.0625 4.39545 11.057 4.47811 11.0462 4.55915L13.4302 5.67102C13.7732 5.29663 14.2659 5.06152 14.8125 5.06152C15.2575 5.06152 15.6669 5.21741 15.9888 5.47746L18.6372 3.71206ZM19.8238 3.61817L19.8143 3.60339C19.8108 3.59822 19.8073 3.59312 19.8037 3.5881C19.7301 3.47212 19.6875 3.33468 19.6875 3.1875C19.6875 2.77405 20.0239 2.4375 20.4375 2.4375C20.8511 2.4375 21.1875 2.77405 21.1875 3.1875C21.1875 3.60095 20.8511 3.9375 20.4375 3.9375C20.1841 3.9375 19.9596 3.81115 19.8238 3.61817ZM15.4208 6.4983C15.2845 6.30959 15.0626 6.18652 14.8125 6.18652C14.5185 6.18652 14.2635 6.35655 14.1406 6.60336L14.1334 6.61953C14.1307 6.62532 14.1279 6.63104 14.1251 6.63669C14.0848 6.72857 14.0625 6.82999 14.0625 6.93652C14.0625 7.34998 14.3989 7.68652 14.8125 7.68652C15.2261 7.68652 15.5625 7.34998 15.5625 6.93652C15.5625 6.79327 15.5221 6.65924 15.4521 6.54525C15.4465 6.53771 15.4411 6.52999 15.4358 6.52209C15.4306 6.51424 15.4256 6.50631 15.4208 6.4983ZM9.1875 5.06152C9.48258 5.06152 9.73834 4.89025 9.86071 4.64196L9.86632 4.62954L9.87322 4.61526C9.91453 4.52236 9.9375 4.41957 9.9375 4.31152C9.9375 3.89807 9.60114 3.56152 9.1875 3.56152C8.77386 3.56152 8.4375 3.89807 8.4375 4.31152C8.4375 4.42347 8.46216 4.52978 8.50634 4.6253L8.50841 4.6297L8.50956 4.63218C8.62998 4.88574 8.88856 5.06152 9.1875 5.06152ZM4.23126 6.59721C4.10721 6.35372 3.85405 6.18652 3.5625 6.18652C3.14886 6.18652 2.8125 6.52307 2.8125 6.93652C2.8125 7.34998 3.14886 7.68652 3.5625 7.68652C3.97614 7.68652 4.3125 7.34998 4.3125 6.93652C4.3125 6.83252 4.29122 6.73339 4.25278 6.64326C4.2488 6.63565 4.24498 6.62792 4.24132 6.62006C4.23778 6.61248 4.23443 6.60486 4.23126 6.59721Z"
        fill="white"
      />
      <path
        d="M12.3745 19.3125H12.7499C13.0606 19.3125 13.3124 19.0605 13.3124 18.75C13.3124 18.4395 13.0606 18.1875 12.7499 18.1875H12.3745C12.0638 18.1875 11.812 18.4395 11.812 18.75C11.812 19.0605 12.0638 19.3125 12.3745 19.3125Z"
        fill="white"
      />
      <path
        d="M20.6249 19.3125H20.2495C19.9388 19.3125 19.687 19.0605 19.687 18.75C19.687 18.4395 19.9388 18.1875 20.2495 18.1875H20.6249C20.9356 18.1875 21.1874 18.4395 21.1874 18.75C21.1874 19.0605 20.9356 19.3125 20.6249 19.3125Z"
        fill="white"
      />
      <path
        d="M13.4503 16.4962C13.5602 16.6061 13.7041 16.661 13.848 16.661C13.9919 16.661 14.1359 16.6061 14.2457 16.4962C14.4655 16.2765 14.4655 15.9205 14.2457 15.7008L13.9802 15.4353C13.7605 15.2156 13.4045 15.2156 13.1848 15.4353C12.9651 15.655 12.9651 16.011 13.1848 16.2307L13.4503 16.4962Z"
        fill="white"
      />
      <path
        d="M16.5 15.5632C16.1893 15.5632 15.9375 15.3113 15.9375 15.0007V14.625C15.9375 14.3145 16.1893 14.0625 16.5 14.0625C16.8107 14.0625 17.0625 14.3145 17.0625 14.625V15.0007C17.0625 15.3113 16.8107 15.5632 16.5 15.5632Z"
        fill="white"
      />
      <path
        d="M18.7537 16.4962C18.8635 16.6061 19.0074 16.661 19.1514 16.661C19.2953 16.661 19.4392 16.6061 19.5491 16.4962L19.8146 16.2307C20.0343 16.011 20.0343 15.655 19.8146 15.4353C19.5949 15.2156 19.2389 15.2156 19.0192 15.4353L18.7537 15.7008C18.5339 15.9205 18.5339 16.2765 18.7537 16.4962Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5 21.1875C15.5695 21.1875 14.8125 20.4305 14.8125 19.5C14.8125 18.7666 15.2827 18.141 15.9375 17.9089V16.875C15.9375 16.5645 16.1893 16.3125 16.5 16.3125C16.8107 16.3125 17.0625 16.5645 17.0625 16.875V17.9089C17.7173 18.141 18.1875 18.7666 18.1875 19.5C18.1875 20.4305 17.4305 21.1875 16.5 21.1875ZM16.5 18.9375C16.1898 18.9375 15.9375 19.1898 15.9375 19.5C15.9375 19.8102 16.1898 20.0625 16.5 20.0625C16.8102 20.0625 17.0625 19.8102 17.0625 19.5C17.0625 19.1898 16.8102 18.9375 16.5 18.9375Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.6875 18.75C22.6875 16.3504 21.3143 14.2653 19.3125 13.2394V7.3125H21.5625V13.5C21.5625 13.8105 21.8143 14.0625 22.125 14.0625C22.4357 14.0625 22.6875 13.8105 22.6875 13.5V6.75C22.6875 6.43946 22.4357 6.1875 22.125 6.1875H18.75C18.4393 6.1875 18.1875 6.43946 18.1875 6.75V12.7964C17.8248 12.6934 17.4487 12.6228 17.0625 12.5878V10.2129C17.0625 9.90235 16.8107 9.65039 16.5 9.65039H13.125C12.8143 9.65039 12.5625 9.90235 12.5625 10.2129V13.9805C11.3248 15.0041 10.4906 16.4993 10.3378 18.188H8.0625V8.30469H10.3125V13.5001C10.3125 13.8107 10.5643 14.0626 10.875 14.0626C11.1857 14.0626 11.4375 13.8107 11.4375 13.5001V7.74219C11.4375 7.43164 11.1857 7.17969 10.875 7.17969H7.5C7.18927 7.17969 6.9375 7.43164 6.9375 7.74219V18.188H5.8125V10.2119C5.8125 9.90137 5.56073 9.64941 5.25 9.64941H1.875C1.56427 9.64941 1.3125 9.90137 1.3125 10.2119V18.7505C1.3125 19.061 1.56427 19.313 1.875 19.313H10.3378C10.441 20.4531 10.8577 21.5325 11.5582 22.4634C11.6646 22.6044 11.831 22.6875 12.0077 22.6875H20.9923C21.169 22.6875 21.3354 22.6044 21.4418 22.4634C22.2567 21.3805 22.6875 20.0966 22.6875 18.75ZM21.5625 18.75C21.5625 15.9648 19.302 13.698 16.5194 13.6875C16.513 13.6878 16.5065 13.6879 16.5 13.6879C16.4935 13.6879 16.487 13.6878 16.4806 13.6875C13.698 13.698 11.4375 15.9648 11.4375 18.75C11.4375 19.7589 11.7339 20.7257 12.2974 21.5625H20.7026C21.2661 20.7257 21.5625 19.7589 21.5625 18.75ZM15.9375 10.7754V12.5878C15.1336 12.6606 14.3736 12.8878 13.6875 13.2394V10.7754H15.9375ZM2.4375 18.188H4.6875V10.7744H2.4375V18.188Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6372 3.71206C18.5886 3.54554 18.5625 3.36951 18.5625 3.1875C18.5625 2.15368 19.4037 1.3125 20.4375 1.3125C21.4713 1.3125 22.3125 2.15368 22.3125 3.1875C22.3125 4.22131 21.4713 5.0625 20.4375 5.0625C19.9929 5.0625 19.584 4.90695 19.2622 4.64741L16.6132 6.41325C16.6616 6.57939 16.6875 6.75499 16.6875 6.93652C16.6875 7.97034 15.8463 8.81152 14.8125 8.81152C13.7787 8.81152 12.9375 7.97034 12.9375 6.93652C12.9375 6.85297 12.943 6.77068 12.9536 6.68999L10.5691 5.57783C10.2261 5.95175 9.73366 6.18652 9.1875 6.18652C8.6414 6.18652 8.14905 5.9518 7.80604 5.57795L5.42141 6.6904C5.43202 6.77096 5.4375 6.85312 5.4375 6.93652C5.4375 7.97034 4.59631 8.81152 3.5625 8.81152C2.52868 8.81152 1.6875 7.97034 1.6875 6.93652C1.6875 5.90271 2.52868 5.06152 3.5625 5.06152C4.10915 5.06152 4.60193 5.29671 4.94498 5.67121L7.32878 4.55914C7.31804 4.47811 7.3125 4.39545 7.3125 4.31152C7.3125 3.27771 8.15369 2.43652 9.1875 2.43652C10.2213 2.43652 11.0625 3.27771 11.0625 4.31152C11.0625 4.39545 11.057 4.47811 11.0462 4.55915L13.4302 5.67102C13.7732 5.29663 14.2659 5.06152 14.8125 5.06152C15.2575 5.06152 15.6669 5.21741 15.9888 5.47746L18.6372 3.71206ZM19.8238 3.61817L19.8143 3.60339C19.8108 3.59822 19.8073 3.59312 19.8037 3.5881C19.7301 3.47212 19.6875 3.33468 19.6875 3.1875C19.6875 2.77405 20.0239 2.4375 20.4375 2.4375C20.8511 2.4375 21.1875 2.77405 21.1875 3.1875C21.1875 3.60095 20.8511 3.9375 20.4375 3.9375C20.1841 3.9375 19.9596 3.81115 19.8238 3.61817ZM15.4208 6.4983C15.2845 6.30959 15.0626 6.18652 14.8125 6.18652C14.5185 6.18652 14.2635 6.35655 14.1406 6.60336L14.1334 6.61953C14.1307 6.62532 14.1279 6.63104 14.1251 6.63669C14.0848 6.72857 14.0625 6.82999 14.0625 6.93652C14.0625 7.34998 14.3989 7.68652 14.8125 7.68652C15.2261 7.68652 15.5625 7.34998 15.5625 6.93652C15.5625 6.79327 15.5221 6.65924 15.4521 6.54525C15.4465 6.53771 15.4411 6.52999 15.4358 6.52209C15.4306 6.51424 15.4256 6.50631 15.4208 6.4983ZM9.1875 5.06152C9.48258 5.06152 9.73834 4.89025 9.86071 4.64196L9.86632 4.62954L9.87322 4.61526C9.91453 4.52236 9.9375 4.41957 9.9375 4.31152C9.9375 3.89807 9.60114 3.56152 9.1875 3.56152C8.77386 3.56152 8.4375 3.89807 8.4375 4.31152C8.4375 4.42347 8.46216 4.52978 8.50634 4.6253L8.50841 4.6297L8.50956 4.63218C8.62998 4.88574 8.88856 5.06152 9.1875 5.06152ZM4.23126 6.59721C4.10721 6.35372 3.85405 6.18652 3.5625 6.18652C3.14886 6.18652 2.8125 6.52307 2.8125 6.93652C2.8125 7.34998 3.14886 7.68652 3.5625 7.68652C3.97614 7.68652 4.3125 7.34998 4.3125 6.93652C4.3125 6.83252 4.29122 6.73339 4.25278 6.64326C4.2488 6.63565 4.24498 6.62792 4.24132 6.62006C4.23778 6.61248 4.23443 6.60486 4.23126 6.59721Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
      <path
        d="M12.3745 19.3125H12.7499C13.0606 19.3125 13.3124 19.0605 13.3124 18.75C13.3124 18.4395 13.0606 18.1875 12.7499 18.1875H12.3745C12.0638 18.1875 11.812 18.4395 11.812 18.75C11.812 19.0605 12.0638 19.3125 12.3745 19.3125Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
      <path
        d="M20.6249 19.3125H20.2495C19.9388 19.3125 19.687 19.0605 19.687 18.75C19.687 18.4395 19.9388 18.1875 20.2495 18.1875H20.6249C20.9356 18.1875 21.1874 18.4395 21.1874 18.75C21.1874 19.0605 20.9356 19.3125 20.6249 19.3125Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
      <path
        d="M13.4503 16.4962C13.5602 16.6061 13.7041 16.661 13.848 16.661C13.9919 16.661 14.1359 16.6061 14.2457 16.4962C14.4655 16.2765 14.4655 15.9205 14.2457 15.7008L13.9802 15.4353C13.7605 15.2156 13.4045 15.2156 13.1848 15.4353C12.9651 15.655 12.9651 16.011 13.1848 16.2307L13.4503 16.4962Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
      <path
        d="M16.5 15.5632C16.1893 15.5632 15.9375 15.3113 15.9375 15.0007V14.625C15.9375 14.3145 16.1893 14.0625 16.5 14.0625C16.8107 14.0625 17.0625 14.3145 17.0625 14.625V15.0007C17.0625 15.3113 16.8107 15.5632 16.5 15.5632Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
      <path
        d="M18.7537 16.4962C18.8635 16.6061 19.0074 16.661 19.1514 16.661C19.2953 16.661 19.4392 16.6061 19.5491 16.4962L19.8146 16.2307C20.0343 16.011 20.0343 15.655 19.8146 15.4353C19.5949 15.2156 19.2389 15.2156 19.0192 15.4353L18.7537 15.7008C18.5339 15.9205 18.5339 16.2765 18.7537 16.4962Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5 21.1875C15.5695 21.1875 14.8125 20.4305 14.8125 19.5C14.8125 18.7666 15.2827 18.141 15.9375 17.9089V16.875C15.9375 16.5645 16.1893 16.3125 16.5 16.3125C16.8107 16.3125 17.0625 16.5645 17.0625 16.875V17.9089C17.7173 18.141 18.1875 18.7666 18.1875 19.5C18.1875 20.4305 17.4305 21.1875 16.5 21.1875ZM16.5 18.9375C16.1898 18.9375 15.9375 19.1898 15.9375 19.5C15.9375 19.8102 16.1898 20.0625 16.5 20.0625C16.8102 20.0625 17.0625 19.8102 17.0625 19.5C17.0625 19.1898 16.8102 18.9375 16.5 18.9375Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.6875 18.75C22.6875 16.3504 21.3143 14.2653 19.3125 13.2394V7.3125H21.5625V13.5C21.5625 13.8105 21.8143 14.0625 22.125 14.0625C22.4357 14.0625 22.6875 13.8105 22.6875 13.5V6.75C22.6875 6.43946 22.4357 6.1875 22.125 6.1875H18.75C18.4393 6.1875 18.1875 6.43946 18.1875 6.75V12.7964C17.8248 12.6934 17.4487 12.6228 17.0625 12.5878V10.2129C17.0625 9.90235 16.8107 9.65039 16.5 9.65039H13.125C12.8143 9.65039 12.5625 9.90235 12.5625 10.2129V13.9805C11.3248 15.0041 10.4906 16.4993 10.3378 18.188H8.0625V8.30469H10.3125V13.5001C10.3125 13.8107 10.5643 14.0626 10.875 14.0626C11.1857 14.0626 11.4375 13.8107 11.4375 13.5001V7.74219C11.4375 7.43164 11.1857 7.17969 10.875 7.17969H7.5C7.18927 7.17969 6.9375 7.43164 6.9375 7.74219V18.188H5.8125V10.2119C5.8125 9.90137 5.56073 9.64941 5.25 9.64941H1.875C1.56427 9.64941 1.3125 9.90137 1.3125 10.2119V18.7505C1.3125 19.061 1.56427 19.313 1.875 19.313H10.3378C10.441 20.4531 10.8577 21.5325 11.5582 22.4634C11.6646 22.6044 11.831 22.6875 12.0077 22.6875H20.9923C21.169 22.6875 21.3354 22.6044 21.4418 22.4634C22.2567 21.3805 22.6875 20.0966 22.6875 18.75ZM21.5625 18.75C21.5625 15.9648 19.302 13.698 16.5194 13.6875C16.513 13.6878 16.5065 13.6879 16.5 13.6879C16.4935 13.6879 16.487 13.6878 16.4806 13.6875C13.698 13.698 11.4375 15.9648 11.4375 18.75C11.4375 19.7589 11.7339 20.7257 12.2974 21.5625H20.7026C21.2661 20.7257 21.5625 19.7589 21.5625 18.75ZM15.9375 10.7754V12.5878C15.1336 12.6606 14.3736 12.8878 13.6875 13.2394V10.7754H15.9375ZM2.4375 18.188H4.6875V10.7744H2.4375V18.188Z"
        stroke="#fff"
        stroke-width="2"
        mask="url(#path-1-inside-1_990_2931)"
      />
    </svg>
  );
};
const menuData = [
  {
    title: "Dashboard",
    path: "/",
    icon: <DashboardIcon />,
  },
  {
    title: "Account Stats",
    path: "/account-stats",
    icon: <AccountMetricsIcon />,
  },
  // {
  //   title: "AlphaTicks",
  //   path: "/performance-tracker",
  //   icon: <AlphaTicksIcon />,
  // },
  {
    title: "Assessments",
    path: "/Assessments",
    icon: <GetFundedIcon />,
  },
  {
    title: "Competition",
    path: "/competition",
    icon: <CompetitionIcon />,
  },
  {
    title: "Affiliate",
    path: "/affiliate",
    icon: <AffiliateIcon />,
  },
  {
    title: "Profile",
    path: "/profile",
    icon: <ProfileIcon />,
  },

  {
    title: "Billing Details",
    path: "/billing-details",
    icon: <BillingIcon />,
  },
  // {
  //   title: "Accounts",
  //   path: "/accounts",
  //   icon: <AccountsIcon />,
  // },
  // {
  //   title: "Leaderboard",
  //   path: "/leaderboard",
  //   icon: <LeaderboardIcon />,
  // },

  {
    title: "Payout",
    path: "/payout",
    icon: <PayoutIcon />,
  },
  {
    title: "Achievements",
    path: "/certificates",
    icon: <CertificatesIcon />,
  },
  {
    title: "Contracts",
    path: "/contract-lists",
    icon: <Contract />,
  },
  // {
  //   title: "Downloads",
  //   path: "/downloads",
  //   icon: <DownloadsIcon />,
  // },
];

export default menuData;
